<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info">
        <h5 style="margin-bottom:10px;">Exportar programación mensual</h5>
        <p style="margin-bottom:10px;">Seleccione el mes que desea exportar</p>
        <select v-model="selectedDate"  style="height:60px;background-color:whitesmoke;padding-left:10px">
         <option v-for="(date,i) in myDates" :key="i" :value="date" :selected="fecha==date?'selected':false">{{date|dateFilter}}</option>
        </select>
        <h5  class="login__sect-right__form--error" style="font-size: 13px; font-family: Inter UI Regular">{{errorMessage}}</h5>
      </div>
      <div class="modal_password__modal__buttons">
        <a v-if="selectedDate.length>0" style="color:black;text-align:center;align-content:center;padding-top:15px" class="modal_password__modal__buttons--left" :href="finalLink" @click="$emit('export')"><header>EXPORTAR</header></a> 
        <div style="cursor:no-drop"  class="modal_password__modal__buttons--left" v-else></div>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
    </section>
  </article>
</template>

<script>
import moment from 'moment'
export default {
  data(){
    return{
      fecha:"",
      errorMessage:"",
      myDates:[],
      selectedDate:'',
    }
  },
  props:{
    dates:{
      type: Array,
    },    
  },
  methods:{
    onCancelModal(event){
      this.$emit('cancel', false);
    },
  },
  mounted(){
    this.fecha= moment().format('YYYY-MM');
    this.dates=this.dates.sort((a, b) => a.date < b.date);
    console.log("MODIFIED")
    console.log(this.dates);
    this.myDates=this.dates.map(function(value) {
      return value.date;
    }).sort();
    if(this.myDates.indexOf(this.fecha)>=0){
      this.selectedDate=this.fecha;
    }
  },
  filters: {
    dateFilter(value){
        let month=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        var myDate=new Date(value); 
        myDate.setDate(myDate.getDate()+1);
        return  month[myDate.getMonth()] + " del " + myDate.getFullYear();
    } 
  },
  computed:{
    finalLink(){
      var arr=this.dates.map(function(value) {
                return value.date;
              })
      let pos=arr.indexOf(this.selectedDate);
      let link=null;
      if(pos>=0){
        link = (this.dates[pos].url.url).indexOf("/Test") > 0 ? (this.dates[pos].url.url).replace('/Test', '') : this.dates[pos].url.url;
      }
      return link;
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalExportSchedule.vue